/*
 * Solorent – Carrello preventivi
 * ------------------------------------------------------------------
 * - "Aggiungi al preventivo" su schede e liste: salva prodotto + variante
 *   (percorrenza / anticipo / durata) nel browser (localStorage).
 * - Contatore sui link al carrello preventivi (anche i vecchi /pages/request-for-quote).
 * - Pagina /pages/richiesta-preventivo: elenco, cambio combinazione, modulo,
 *   invio a Salesforce (Apex REST) con dati di provenienza (sr-attribution.js).
 * - Blocca l'aggiunta al carrello Shopify e reindirizza /cart al preventivo.
 *
 * Compatibile con InstantClick (cambio pagina senza ricaricamento).
 */
(function () {
  'use strict';
  if (window.__srQuoteLoaded) return; // il tema può rieseguire gli script dopo un cambio pagina
  window.__srQuoteLoaded = true;

  var KEY = 'sr_quote_v1';
  var SCHEMA = 'solorent.quote.v1';

  function C() { return window.SR_CONFIG || {}; }
  function maxItems() { return C().maxItems || 10; }
  function quoteUrl() { return C().quoteUrl || '/pages/richiesta-preventivo'; }

  /* ================= storage ================= */
  function load() {
    try {
      var d = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (d && Array.isArray(d.items)) return d;
    } catch (e) { /* ignore */ }
    return { items: [] };
  }
  function save(d) {
    d.updated = Date.now();
    try { window.localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* ignore */ }
    refreshCounters();
    try { document.dispatchEvent(new CustomEvent('sr:quote:change', { detail: d })); } catch (e) { /* ignore */ }
  }

  /* ================= utility ================= */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    try { return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
  function toNum(v) {
    if (v == null) return null;
    var s = String(v).toUpperCase();
    if (/ZERO/.test(s)) return 0;
    var d = s.replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : null;
  }
  function findVariant(product, id) {
    var vs = product.variants || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i];
    return null;
  }
  // ricava km / anticipo / durata dai nomi delle opzioni della variante
  function combo(product, variant) {
    var names = product.options || [];
    var vals = [variant.o1, variant.o2, variant.o3];
    var r = { km: null, anticipo: null, durata_mesi: null, etichetta_anticipo: '', labels: [] };
    names.forEach(function (n, i) {
      var N = String(n).toUpperCase();
      var v = vals[i];
      r.labels.push({ name: n, value: v });
      if (/PERCORREN|KM/.test(N)) r.km = toNum(v);
      else if (/ANTICIPO/.test(N)) { r.anticipo = toNum(v); r.etichetta_anticipo = n; }
      else if (/DURATA|MESI/.test(N)) r.durata_mesi = toNum(v);
    });
    return r;
  }
  function pathOf(href) {
    try { return new URL(href, location.href).pathname.replace(/\/$/, ''); } catch (e) { return ''; }
  }
  function isQuoteLink(a) {
    var raw = a && a.getAttribute('href');
    // "#" e "javascript:" puntano alla pagina corrente: non sono link al preventivo
    if (!raw || raw.charAt(0) === '#' || /^javascript:/i.test(raw)) return false;
    var p = pathOf(raw);
    var urls = [quoteUrl()].concat(C().legacyQuoteUrls || []);
    return urls.some(function (u) { return pathOf(u) === p; });
  }

  /* ================= contatori e link ================= */
  function refreshCounters() {
    var n = load().items.length;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!isQuoteLink(a)) continue;
      // i vecchi link dell'app puntano alla nuova pagina
      if (pathOf(a.getAttribute('href')) !== pathOf(quoteUrl())) a.setAttribute('href', quoteUrl());
      if (a.closest('[data-sr-quote-page]')) continue;
      // niente contatore sui link-immagine dei mega menu
      if (a.querySelector('img, .image-element__wrap')) continue;
      var b = a.querySelector('.sr-quote-count');
      if (!b) {
        // <b> e non <span>: il menu mobile di Turbo associa i suoi comandi agli span dei link
        b = document.createElement('b');
        b.className = 'sr-quote-count';
        b.setAttribute('aria-label', 'offerte nel preventivo');
        a.appendChild(b);
      }
      b.textContent = n;
      b.hidden = n === 0;
    }
  }

  /* ================= aggiunta al preventivo ================= */
  function addItem(product, variantId) {
    var d = load();
    var v = findVariant(product, variantId) || findVariant(product, product.default_variant_id);
    if (!v) return { status: 'error' };
    for (var i = 0; i < d.items.length; i++) {
      if (String(d.items[i].variant_id) === String(v.id)) return { status: 'exists', variant: v };
    }
    if (d.items.length >= maxItems()) return { status: 'full' };
    d.items.push({ variant_id: v.id, product: product, added: Date.now() });
    delete d.pending_id; // il contenuto è cambiato: nuova richiesta
    save(d);
    return { status: 'added', variant: v };
  }

  function panel() {
    var p = document.getElementById('sr-quote-panel');
    if (p) return p;
    p = document.createElement('div');
    p.id = 'sr-quote-panel';
    p.className = 'sr-quote-panel';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-live', 'polite');
    p.setAttribute('aria-label', 'Carrello preventivi');
    p.hidden = true;
    document.body.appendChild(p);
    p.addEventListener('click', function (e) {
      if (e.target.closest('[data-sr-panel-close]')) { e.preventDefault(); p.hidden = true; }
    });
    return p;
  }
  function showPanel(result, product) {
    var p = panel();
    var n = load().items.length;
    var title, body = '';
    if (result.status === 'added' || result.status === 'exists') {
      var c = combo(product, result.variant);
      title = result.status === 'added' ? 'Offerta aggiunta al preventivo' : 'Questa offerta è già nel preventivo';
      body = '<p class="sr-quote-panel__car">' + esc(product.modello) + '</p>' +
        '<p class="sr-quote-panel__combo">' + c.labels.map(function (l) { return esc(l.value); }).join(' · ') + '</p>';
    } else if (result.status === 'full') {
      title = 'Hai già ' + maxItems() + ' offerte nel preventivo';
      body = '<p>Invia questa richiesta o rimuovi un’offerta per aggiungerne altre.</p>';
    } else {
      title = 'Non siamo riusciti ad aggiungere l’offerta';
      body = '<p>Riprova oppure contattaci.</p>';
    }
    p.innerHTML =
      '<button type="button" class="sr-quote-panel__x" data-sr-panel-close aria-label="Chiudi">×</button>' +
      '<p class="sr-quote-panel__title">' + esc(title) + '</p>' + body +
      '<div class="sr-quote-panel__actions">' +
      '<a class="global-button global-button--primary" href="' + esc(quoteUrl()) + '">Richiedi il preventivo (' + n + ')</a>' +
      '<a href="#" class="sr-quote-panel__link" data-sr-panel-close>Continua a scegliere</a>' +
      '</div>';
    p.hidden = false;
    clearTimeout(showPanel._t);
    showPanel._t = setTimeout(function () { p.hidden = true; }, 12000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sr-quote-add]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.sr-quote-buttons');
    var jsonEl = wrap && wrap.querySelector('[data-sr-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = btn.closest('form') || btn.closest('[data-product-form]');
    // Turbo 11: variante corrente nel campo nascosto name="id" del selettore varianti
    var sel = form && form.querySelector('[name="id"]');
    var vid = sel && sel.value ? sel.value : product.default_variant_id;
    var res = addItem(product, vid);
    if (res.status === 'added') {
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
    }
    showPanel(res, product);
  });

  // nessuna aggiunta al carrello Shopify: il sito raccoglie solo richieste di preventivo
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var action = f && f.getAttribute && (f.getAttribute('action') || '');
    if (/\/cart\/add/.test(action)) e.preventDefault();
  }, true);

  // altre schede del browser aperte sul sito
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { refreshCounters(); renderPage(); }
  });

  /* ================= pagina carrello preventivi ================= */
  var pageState = { started: 0 };

  function root() { return document.querySelector('[data-sr-quote-page]'); }

  function renderPage() {
    var R = root();
    if (!R) return;
    var d = load();
    var list = R.querySelector('[data-sr-quote-items]');
    var empty = R.querySelector('[data-sr-quote-empty]');
    var filled = R.querySelector('[data-sr-quote-filled]');
    var badge = R.querySelector('[data-sr-quote-n]');
    empty.hidden = d.items.length > 0;
    filled.hidden = d.items.length === 0;
    if (badge) badge.textContent = d.items.length ? '(' + d.items.length + ')' : '';
    list.innerHTML = d.items.map(function (it, idx) {
      var p = it.product;
      var v = findVariant(p, it.variant_id) || {};
      var c = combo(p, v);
      var legend = (p.options || []).map(function (o) { return o; }).join(' / ');
      var opts = (p.variants || []).map(function (x) {
        return '<option value="' + esc(x.id) + '"' + (String(x.id) === String(v.id) ? ' selected' : '') + '>' + esc(x.title) + '</option>';
      }).join('');
      return '<li class="sr-item" data-idx="' + idx + '">' +
        (p.image ? '<img class="sr-item__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="120" height="80">' : '<span class="sr-item__img"></span>') +
        '<div class="sr-item__body">' +
          '<a class="sr-item__title" href="' + esc(p.url) + '">' + esc(p.modello) + '</a>' +
          (p.offerta_riservata ? '<p class="sr-item__offer">' + esc(p.offerta_riservata) + '</p>' : '') +
          '<label class="sr-item__combo"><span>' + esc(legend) + '</span>' +
            '<select data-sr-variant aria-label="Combinazione per ' + esc(p.modello) + '">' + opts + '</select></label>' +
          '<p class="sr-item__price"><strong>' + esc(money(v.price)) + '</strong> al mese' +
            (p.regime_iva ? ' <small>' + esc(p.regime_iva) + '</small>' : '') + '</p>' +
          (c.etichetta_anticipo ? '<p class="sr-item__note">' + esc(c.etichetta_anticipo.toLowerCase()) + '</p>' : '') +
        '</div>' +
        '<button type="button" class="sr-item__remove" data-sr-remove aria-label="Rimuovi ' + esc(p.modello) + '">Rimuovi</button>' +
      '</li>';
    }).join('');
    updateNotice();
  }

  // avviso se il tipo di cliente non corrisponde alle offerte scelte
  function updateNotice() {
    var R = root(); if (!R) return;
    var notice = R.querySelector('[data-sr-quote-notice]');
    var form = R.querySelector('[data-sr-quote-form]');
    if (!notice) return;
    var cat = categoria(form);
    if (!cat) { notice.hidden = true; return; }
    var items = load().items;
    var solePiva = items.filter(function (i) { return /partit[ae]\s*iva/i.test(i.product.offerta_riservata || ''); });
    var soliPriv = items.filter(function (i) { return /privat/i.test(i.product.offerta_riservata || ''); });
    var msg = '';
    if (cat === 'privato' && solePiva.length) {
      msg = solePiva.length === 1 ? 'Un’offerta che hai scelto è riservata alle partite IVA.' : 'Alcune offerte che hai scelto sono riservate alle partite IVA.';
    } else if (cat !== 'privato' && soliPriv.length) {
      msg = soliPriv.length === 1 ? 'Un’offerta che hai scelto è riservata ai privati.' : 'Alcune offerte che hai scelto sono riservate ai privati.';
    }
    if (msg) msg += ' Invia comunque la richiesta: un consulente ti proporrà l’offerta equivalente per il tuo profilo.';
    notice.textContent = msg;
    notice.hidden = !msg;
  }

  // categoria del tipo cliente scelto (impostata nell'editor): privato | piva | societa
  function categoria(form) {
    var el = form && form.querySelector('input[name="tipo"]:checked');
    if (!el) return '';
    return el.getAttribute('data-categoria') || 'piva';
  }

  function toggleCompany(form) {
    var cat = categoria(form);
    var box = form.querySelector('[data-sr-company]');
    var star = form.querySelector('[data-sr-ragione-star]');
    box.hidden = !cat || cat === 'privato';
    if (star) star.hidden = cat !== 'societa';
  }

  function setError(form, name, msg) {
    var el = form.querySelector('[data-error-for="' + name + '"]');
    var input = form.querySelector('[name="' + name + '"]');
    if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    if (input) {
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
      if (el) { el.id = el.id || ('sr-err-' + name); input.setAttribute('aria-describedby', el.id); }
    }
  }

  function readForm(form) {
    function val(n) { var el = form.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; }
    var tipoEl = form.querySelector('input[name="tipo"]:checked');
    var sceltaEl = form.querySelector('input[name="scelta"]:checked');
    var mk = form.querySelector('[name="marketing"]');
    return {
      scelta: sceltaEl ? sceltaEl.value : '',
      tipo: tipoEl ? tipoEl.value : '',
      categoria: categoria(form),
      nome: val('nome'),
      cognome: val('cognome'),
      ragione_sociale: val('ragione_sociale'),
      partita_iva: val('partita_iva').replace(/\s/g, '').replace(/^IT/i, ''),
      email: val('email'),
      telefono: val('telefono'),
      codice_fiscale: val('codice_fiscale').replace(/\s/g, '').toUpperCase(),
      indirizzo: val('indirizzo'),
      citta: val('citta'),
      provincia: val('provincia'),
      cap: val('cap').replace(/\s/g, ''),
      note: val('note'),
      website: val('website'),
      privacy: !!(form.querySelector('[name="privacy"]') || {}).checked,
      marketing: !!(mk && mk.checked)
    };
  }

  function validate(form, f) {
    var errs = {};
    if (!f.scelta) errs.scelta = 'Scegli se vuoi essere contattato o bloccare l’offerta.';
    if (!f.tipo) errs.tipo = 'Indica se sei un privato, una ditta individuale, un professionista o una società.';
    if (!f.nome) errs.nome = 'Inserisci il nome.';
    if (!f.cognome) errs.cognome = 'Inserisci il cognome.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email)) errs.email = 'Inserisci un indirizzo email valido.';
    var digits = f.telefono.replace(/[^\d]/g, '');
    if (digits.length < 6 || digits.length > 15) errs.telefono = 'Inserisci un numero di cellulare valido.';
    if (f.codice_fiscale && !/^([A-Z0-9]{16}|\d{11})$/.test(f.codice_fiscale)) errs.codice_fiscale = 'Il codice fiscale ha 16 caratteri (11 cifre per le società).';
    if (f.categoria === 'societa' && !f.ragione_sociale) errs.ragione_sociale = 'Inserisci la ragione sociale.';
    if (f.categoria !== 'privato' && f.partita_iva && !/^\d{11}$/.test(f.partita_iva)) errs.partita_iva = 'La partita IVA ha 11 cifre.';
    if (f.cap && !/^\d{5}$/.test(f.cap)) errs.cap = 'Il CAP ha 5 cifre.';
    if (!f.privacy) errs.privacy = 'Per inviarti il preventivo serve il consenso al trattamento dei dati.';
    ['scelta', 'tipo', 'nome', 'cognome', 'telefono', 'email', 'codice_fiscale', 'ragione_sociale', 'partita_iva', 'cap', 'privacy'].forEach(function (k) { setError(form, k, errs[k]); });
    var first = Object.keys(errs)[0];
    if (first) {
      var el = form.querySelector('[name="' + first + '"]');
      if (el && el.focus) el.focus();
    }
    return !first;
  }

  function buildPayload(R, f) {
    var d = load();
    if (!d.pending_id) { d.pending_id = uuid(); save(d); }
    var attr = (window.SRAttribution && window.SRAttribution.get()) || {};
    return {
      schema: SCHEMA,
      request_id: d.pending_id,
      submitted_at: new Date().toISOString(),
      elapsed_ms: Date.now() - pageState.started,
      hp: f.website,
      cliente: {
        scelta: f.scelta, tipo: f.tipo, categoria: f.categoria, nome: f.nome, cognome: f.cognome,
        telefono: f.telefono, email: f.email, codice_fiscale: f.codice_fiscale,
        ragione_sociale: f.categoria === 'privato' ? '' : f.ragione_sociale,
        partita_iva: f.categoria === 'privato' ? '' : f.partita_iva,
        indirizzo: f.indirizzo, citta: f.citta, provincia: f.provincia, cap: f.cap,
        note: f.note
      },
      consensi: {
        privacy: f.privacy,
        marketing: f.marketing,
        versione_informativa: R.getAttribute('data-versione') || ''
      },
      veicoli: d.items.map(function (it) {
        var p = it.product;
        var v = findVariant(p, it.variant_id) || {};
        var c = combo(p, v);
        return {
          product_id: String(p.product_id), variant_id: String(v.id || it.variant_id),
          handle: p.handle, url: p.url, marca: p.marca, modello: p.modello,
          variante: v.title || '', sku: v.sku || '',
          canone: v.price != null ? v.price / 100 : null,
          km: c.km, anticipo: c.anticipo, durata_mesi: c.durata_mesi,
          etichetta_anticipo: c.etichetta_anticipo,
          regime_iva: p.regime_iva || '', offerta_riservata: p.offerta_riservata || '',
          alimentazione: p.alimentazione || '', disponibilita: p.disponibilita || '',
          franchigia: p.franchigia || '', promozione: p.promozione || ''
        };
      }),
      tracking: {
        primo: attr.primo || null,
        ultimo: attr.ultimo || null,
        consenso_marketing: !!attr.consenso_marketing
      },
      contesto: {
        pagina: location.origin + location.pathname,
        user_agent: (navigator.userAgent || '').slice(0, 255),
        lingua: document.documentElement.lang || ''
      }
    };
  }

  function status(R, html, kind) {
    var s = R.querySelector('[data-sr-quote-status]');
    s.className = 'sr-quote__status' + (kind ? ' is-' + kind : '');
    s.innerHTML = html;
    s.hidden = !html;
  }

  // Copia di controllo della richiesta via modulo contatti Shopify (arriva all'email del negozio),
  // indipendente da Salesforce: nessuna richiesta va persa anche se Salesforce non risponde.
  function inviaCopia(payload, esito) {
    try {
      var c = payload.cliente || {};
      var righe = [
        'ESITO: ' + esito,
        'ID richiesta: ' + payload.request_id,
        'Data: ' + new Date().toLocaleString('it-IT'),
        '',
        'Scelta: ' + (c.scelta || '') + ' - Cliente: ' + (c.tipo || ''),
        'Nome: ' + (c.nome || '') + ' ' + (c.cognome || ''),
        'Email: ' + (c.email || '') + ' - Cellulare: ' + (c.telefono || ''),
        c.ragione_sociale ? 'Ragione sociale: ' + c.ragione_sociale : '',
        c.partita_iva ? 'Partita IVA: ' + c.partita_iva : '',
        c.codice_fiscale ? 'Codice fiscale: ' + c.codice_fiscale : '',
        (c.indirizzo || c.citta) ? 'Indirizzo: ' + [c.indirizzo, c.cap, c.citta, c.provincia].filter(Boolean).join(' ') : '',
        c.note ? 'Note: ' + c.note : '',
        'Consenso marketing: ' + ((payload.consensi || {}).marketing ? 'si' : 'no'),
        '',
        'AUTO RICHIESTE:'
      ];
      (payload.veicoli || []).forEach(function (v, i) {
        var nome = (v.modello && v.marca && v.modello.toUpperCase().indexOf(v.marca.toUpperCase()) === 0) ? v.modello : [v.marca, v.modello].filter(Boolean).join(' ');
        var url = v.url ? (/^https?:/i.test(v.url) ? v.url : location.origin + v.url) : '';
        righe.push((i + 1) + ') ' + nome + ' - ' + (v.variante || '') + (v.canone != null ? ' - ' + v.canone + ' euro/mese' : '') + (url ? ' - ' + url : ''));
      });
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[name]', ((c.nome || '') + ' ' + (c.cognome || '')).trim());
      fd.append('contact[email]', c.email || '');
      fd.append('contact[phone]', c.telefono || '');
      fd.append('contact[body]', righe.filter(function (x) { return x !== ''; }).join('\n'));
      var invio = fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', keepalive: true })
        .then(function (res) { return res.ok && !/challenge/i.test(res.url || ''); }, function () { return false; });
      var limite = new Promise(function (ok) { setTimeout(function () { ok(false); }, 6000); });
      return Promise.race([invio, limite]);
    } catch (err) { return Promise.resolve(false); }
  }

  function onSubmit(e) {
    e.preventDefault();
    var R = root(); var form = e.target;
    if (!R || form.__srBusy) return;
    var f = readForm(form);
    if (!validate(form, f)) return;
    if (!load().items.length) { status(R, 'Il preventivo è vuoto.', 'error'); return; }

    var payload = buildPayload(R, f);
    var endpoint = R.getAttribute('data-endpoint');
    var dry = R.getAttribute('data-dry-run') === 'true';
    var btn = form.querySelector('[data-sr-quote-submit]');

    if (dry || !endpoint) {
      var dbg = R.querySelector('[data-sr-quote-debug]');
      dbg.textContent = JSON.stringify(payload, null, 2);
      dbg.hidden = false;
      try { console.log('[Solorent] payload (modalità test)', payload); } catch (err) { /* ignore */ }
      status(R, dry ? 'Modalità test: nessun invio. Qui sotto trovi i dati che verrebbero inviati a Salesforce.' : 'Endpoint Salesforce non configurato nelle impostazioni della sezione.', 'info');
      return;
    }

    form.__srBusy = true;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Invio in corso…';
    status(R, '', '');

    // text/plain = richiesta "semplice": nessun preflight CORS verso Salesforce
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      keepalive: true
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) { return { ok: res.ok, code: res.status, json: json }; });
    }, function () {
      return { ok: false, code: 0, json: {} }; // rete o Salesforce non raggiungibile
    }).then(function (r) {
      var sfOk = !!(r.ok && r.json && r.json.ok);
      if (!sfOk && r.code === 400 && r.json && r.json.errors) return { r: r, copia: false }; // dati da correggere: nessuna copia
      var esito = sfOk ? 'REGISTRATA in Salesforce (' + (r.json.ref || 'senza codice') + ')'
                       : 'NON registrata in Salesforce (' + (r.code ? 'errore HTTP ' + r.code : 'Salesforce non raggiungibile') + ') - INSERIRE A MANO';
      return inviaCopia(payload, esito).then(function (copia) { return { r: r, copia: copia }; });
    }).then(function (x) {
      var r = x.r;
      var salvata = r.ok && r.json && r.json.ok;
      if (salvata || x.copia) {
        var ref = salvata ? (r.json.ref || '') : ('W-' + String(payload.request_id).slice(0, 8).toUpperCase());
        try { window.sessionStorage.setItem('sr_last_ref', ref); } catch (err) { /* ignore */ }
        var evt = { ref: ref, veicoli: payload.veicoli.length, tipo_cliente: payload.cliente.tipo, scelta: payload.cliente.scelta };
        try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('solorent_richiesta_preventivo', evt); } catch (err) { /* ignore */ }
        try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'solorent_richiesta_preventivo' }, evt)); } catch (err) { /* ignore */ }
        save({ items: [] });
        var thanks = R.getAttribute('data-thanks') || '/pages/grazie-della-richiesta';
        window.location.href = thanks + (thanks.indexOf('?') > -1 ? '&' : '?') + 'ref=' + encodeURIComponent(ref);
        return;
      }
      if (r.code === 400 && r.json && r.json.errors) {
        var shown = 0;
        Object.keys(r.json.errors).forEach(function (k) {
          if (form.querySelector('[data-error-for="' + k + '"]')) { setError(form, k, r.json.errors[k]); shown++; }
        });
        status(R, shown ? 'Controlla i campi evidenziati.' : 'Non siamo riusciti a registrare la richiesta: ricarica la pagina e riprova.', 'error');
      } else {
        throw new Error('HTTP ' + r.code);
      }
      done();
    }).catch(function () {
      status(R, (C().errorHtml || 'Non siamo riusciti a inviare la richiesta. Riprova tra qualche istante oppure scrivici a <a href="mailto:info@solorent.it">info@solorent.it</a>.'), 'error');
      done();
    });

    function done() { form.__srBusy = false; btn.disabled = false; btn.textContent = label; }
  }

  // aggiorna i canoni dal catalogo attuale (i prezzi possono essere cambiati dopo l'aggiunta)
  function refreshPrices() {
    var d = load();
    var handles = {};
    d.items.forEach(function (it) { handles[it.product.handle] = true; });
    Object.keys(handles).forEach(function (h) {
      fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          var dd = load(); var changed = false;
          dd.items.forEach(function (it) {
            if (it.product.handle !== h) return;
            it.product.variants = p.variants.map(function (v) {
              return { id: v.id, title: v.title, sku: v.sku, price: v.price, o1: v.option1, o2: v.option2, o3: v.option3 };
            });
            changed = true;
          });
          if (changed) { save(dd); renderPage(); }
        }).catch(function () { /* offline o prodotto rimosso: si usano i dati salvati */ });
    });
  }

  function initPage() {
    var R = root();
    if (!R || R.__srInit) return;
    R.__srInit = true;
    pageState.started = Date.now();
    var form = R.querySelector('[data-sr-quote-form]');

    R.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-sr-remove]');
      if (!rm) return;
      var li = rm.closest('[data-idx]');
      var d = load();
      d.items.splice(parseInt(li.getAttribute('data-idx'), 10), 1);
      delete d.pending_id;
      save(d); renderPage();
    });
    R.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sr-variant]');
      if (sel) {
        var idx = parseInt(sel.closest('[data-idx]').getAttribute('data-idx'), 10);
        var d = load();
        var dup = d.items.some(function (it, i) { return i !== idx && String(it.variant_id) === String(sel.value); });
        if (dup) d.items.splice(idx, 1); else d.items[idx].variant_id = sel.value;
        delete d.pending_id;
        save(d); renderPage();
        return;
      }
      if (e.target.name === 'tipo') { toggleCompany(form); updateNotice(); setError(form, 'tipo', ''); }
      if (e.target.name === 'scelta') setError(form, 'scelta', '');
    });
    form.addEventListener('submit', onSubmit);
    // l'errore di un campo sparisce appena l'utente lo corregge
    form.addEventListener('input', function (e) { if (e.target.name) setError(form, e.target.name, ''); });
    form.addEventListener('change', function (e) { if (e.target.name === 'privacy') setError(form, 'privacy', ''); });
    toggleCompany(form);
    renderPage();
    refreshPrices();
  }

  /* ================= avvio ================= */
  function init() {
    var path = location.pathname.replace(/\/$/, '');
    if (path === '/cart') { location.replace(quoteUrl()); return; }
    refreshCounters();
    initPage();
    var ref = document.querySelectorAll('[data-sr-quote-ref]');
    if (ref.length) {
      var v = '';
      try { v = window.sessionStorage.getItem('sr_last_ref') || ''; } catch (e) { /* ignore */ }
      for (var i = 0; i < ref.length; i++) ref[i].textContent = v;
    }
  }
  function hookInstantClick() {
    if (hookInstantClick.done || !window.InstantClick || typeof window.InstantClick.on !== 'function') return;
    hookInstantClick.done = true;
    window.InstantClick.on('change', init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('DOMContentLoaded', hookInstantClick);
  window.addEventListener('load', hookInstantClick);

  window.SRQuote = { load: load, add: addItem, refresh: init };
})();
